import CRM from "../img/Banner/CRM.png";
import ERP from "../img/Banner/ERP.png";

import DataIntegration from "../img/banners/integration.png";

import Image7 from "../img/Banner/img7.png";

import Image8 from "../img/banners/cloud.png";
import AI from "../img/Banner/`Ai.png";

import OpenAI from "../img/icons/openai.png";
import Gemini from "../img/icons/gemini.png";
import CoPilot from "../img/icons/copilot.png";
import Llama from "../img/icons/olaama.png";
import CRMService from "../img/Banner/CRM-service1.png";
import homeBanner from "../img/Banner/whats-new-submit.jpeg";
import ZohoCRM from "../img/icons/zohopartner.png";
import SalesForce from "../img/icons/salesforcepartner.png";
import HubSpot from "../img/icons/hubspot.png";
import AWS from "../img/icons/aws.png";
import Azure from "../img/icons/azure-pngFormat.png";
import GCP from "../img/icons/gcp-pngFormat.png";
import OracleNetSuite from "../img/icons/oracle-partner.png";
import OracleEBS from "../img/icons/oracle-e-business.png";
import SapHana from "../img/icons/saphana.png";
import Microsoft365 from "../img/icons/m365.jpg";
import ustpnFlyer from "../img/Banner/whatsnew-flyer.jpeg";
import DataAnalytics from "../img/icons/DataAnalytics.jpg";
import DataWarehouse from "../img/icons/DataWarehouse.jpg";
import DataMigration from "../img/icons/datamigration.jpg";

import flyerAdvt from "../img/flyer-Advt-draft.jpg"
import TiaraTimesheetIcon from "../img/productsicons/timesheet.png";
import CrmIcon from "../img/productsicons/erp.png";
import CentroidIcon from "../img/productsicons/centroidicon.png";
// import ErpIcon from "../img/icons/erp.png";
import help from "../img/productsicons/helpdesk.png";
import TipsIcon from "../img/productsicons/dataintegration (1).png";

export const sliderItems = [
  {
    src: homeBanner,
    src1: ustpnFlyer,
    title: "",
    tileContent: "What's New",
    menuName: "WhatIsNew",
  },
  //   {
  //     src:flyerAdvt,
  //   title: "",
  //   tileContent: "Tiara Overview",
  //   menuName: "TiaraOverview",
  // },
  {
    src: CRMService,
    title: "",
    tileContent: "Service CRM",
    menuName: "ServiceCRM",
    para: "IT Service Mgmt (ITSM) , Customer Service (CSM), HR Service Delivery (HRSD), IT Operations (ITOM), IT Asset Mgmt (ITAM), Public Sector (PSDS), AI Experiences (Now Assist), Security Ops (SecOps), Config Mgmt (CMDB), ITOM AIOps, Procurement, Strategic Portfolio (SPM)"


    // para: "IT Service Management (ITSM) , Customer Service Management (CSM), HR Service Delivery (HRSD), IT Operations Management (ITOM), IT Asset Management (ITAM), Public Sector Digital Services (PSDS),AI Experiences (Now Assist), Security Operations (SecOps)  ",
  },
  {
    src: CRM,
    title: "",
    tileContent: "Sales CRM",
    menuName: "SalesCRM",
    para: "Zoho Authorized Partner, Salesforce Partner, Microsoft Dynamic 365, HubSpot",
  },
  {
    src: AI,
    title: "AI Solutions",
    tileContent: "AI Solutions",
    menuName: "AI",
    para: "OpenAI, Gemini, CoPilot, Llama",
  },
  {
    src: ERP,
    title: "ERP Solutions",
    tileContent: "ERP",
    menuName: "ERP",
    para: "Oracle NetSuite, Oracle EBS, SAP HANA",
  },
  {
    src: DataWarehouse,
    src1: DataAnalytics,
    src2: DataMigration,
    title: "Data Engineering",
    tileContent: "Data Engineering",
    menuName: "DI",
    para: "Offers own Cloud based Data Integration platform - www.tiaraintegration.com",
  },
  {
    src: Image8,
    title: "Cloud Solutions",
    tileContent: "Cloud Solutions",
    menuName: "Cloud",
    para: "AWS, Azure, GCP",
  },
  {
    src: Image7,
    title: "Products",
    tileContent: "Products",
    menuName: "Products",
    para: "Timesheet, Centroid, CRM | ERP, Help Desk, Integration ",
  },
];

export const salesCRMIcons = {
  "Zoho Authorized Partner": ZohoCRM,
  "Salesforce Partner": SalesForce,
  HubSpot: HubSpot,
  "Microsoft Dynamic 365": Microsoft365,
};

export const erpIcons = {
  "Oracle NetSuite": OracleNetSuite,
  "Oracle EBS": OracleEBS,
  "SAP HANA": SapHana,
};

export const aiIcons = {
  OpenAI,
  Gemini,
  CoPilot,
  Llama,
};

export const cloudIcons = {
  AWS: {
    icon: AWS,
    description:
      "Comprehensive cloud platform offering compute, storage, and database services with global infrastructure.",
  },
  Azure: {
    icon: Azure,
    description:
      "Microsoft's cloud platform with seamless hybrid cloud capabilities and enterprise-grade security.",
  },
  GCP: {
    icon: GCP,
    description:
      "Google Cloud Platform specializing in AI/ML, data analytics, and scalable infrastructure solutions.",
  },
};

export const productsIcons = {
  Centroid: {
    icon: CentroidIcon,
    description:
      "Centralized management platform for unified business operations and analytics.",
    className: "product-centroid",
  },

  Timesheet: {
    icon: TiaraTimesheetIcon,
    description:
      "Comprehensive time tracking and project management solution for workforce optimization.",
    className: "product-timesheet",
  },

  Integration: {
    icon: TipsIcon,
    description:
      "Enterprise-grade integration platform for seamless data connectivity across applications.",
    className: "product-integration",
  },

  "CRM | ERP": {
    icon: CrmIcon,
    description:
      "Customer relationship management solution designed for sales automation and customer engagement.",
    className: "product-crm",
  },

  "Help Desk": {
    icon: help,
    description:
      "End-to-end enterprise resource planning system for streamlined business processes.",
    className: "product-helpdesk",
  },
};
